import { CommonModule, DatePipe } from '@angular/common';
import { Component, input } from '@angular/core';
import { CalendarEvent } from '../../../calendar.types';
import { CalendarRepeatIcon } from '../../../etc/repeat-icon/repeat-icon.component';
import { Icon } from 'libs/client-libs/src/components/components';

/**
 * @export BlockCalendarEventContent
 * @description 이벤트의 내용을 담당한다. 이벤트의 내용을 변경하고 싶다면 해당 컴포넌트를 참조
 */

@Component({
  selector: '[eventContent]',
  templateUrl: './event-content.component.html',
  standalone: true,
  imports: [DatePipe, Icon, CommonModule, CalendarRepeatIcon],
})
export class BlockCalendarEventContent {
  event = input.required<CalendarEvent>();
  width = input.required<number>();
}
